import {
  AIOnboardingModalFormFieldConfiguration,
  AIOnboardingModalFormShape,
} from '@/modules/aiOnboarding/AIOnboardingModal/AIOnboardingModalForm/AIOnboardingModalForm.types';

export const AI_ONBOARDING_MODAL_FORM_TABLE_STYLE_CONFIGS: AIOnboardingModalFormFieldConfiguration =
  {
    individuals: {
      columns: {
        firstName: {
          columnHeader: 'First name',
          columnWidth: 4,
        },
        middleName: {
          columnHeader: 'Middle name',
          columnWidth: 3,
        },
        lastName: {
          columnHeader: 'Last name',
          columnWidth: 4,
        },
        suffix: {
          columnHeader: 'Suffix',
          columnWidth: 1,
        },
        relationshipToPrimaryClient1: {
          columnHeader: '',
          columnWidth: 6,
        },
        relationshipToPrimaryClient2: {
          columnHeader: '',
          columnWidth: 6,
        },
      },
      styles: {
        rowPaddingVertical: 2,
        columnPaddingHorizontal: 1,
      },
    },
    organizations: {
      columns: {
        organizationName: {
          columnHeader: 'Name of organization',
          columnWidth: 8,
        },
        organizationKind: { columnHeader: 'Type', columnWidth: 4 },
      },
      styles: {
        rowPaddingVertical: 1,
        columnPaddingHorizontal: 3,
      },
    },
    entities: {
      columns: {
        entityType: { columnHeader: 'Type', columnWidth: 3 },
        entityName: { columnHeader: 'Entity name', columnWidth: 5 },
        principalIds: {
          columnHeader: 'Grantor/owner/donor',
          columnWidth: 4,
        },
        principalId: {
          columnHeader: '',
          columnWidth: 4,
        },
        integrationEntityIds: { columnHeader: '', columnWidth: 12 },
        assetCategoryId: {
          columnHeader: '', // No header because it's not the "main" field row.
          columnSubheader: 'Asset category',
          columnWidth: 4,
        },
        currentMarketValue: {
          columnHeader: '', // No header because it's not the "main" field row.
          columnSubheader: 'Total market value',
          columnWidth: 4,
        },
        dateOfValuation: {
          columnHeader: '', // No header because it's not the "main" field row.
          columnSubheader: 'Date of valuation',
          columnWidth: 4,
        },
      },
      styles: {
        rowPaddingVertical: 2,
        columnPaddingHorizontal: 1,
      },
    },
    testamentaryEntities: {
      columns: {
        testamentaryEntityKind: { columnHeader: 'Type', columnWidth: 3 },
        testamentaryEntityName: {
          columnHeader: 'Sub-trust name',
          columnWidth: 6,
        },
        testamentaryEntityAssetLocation: {
          columnHeader: 'Asset location',
          columnWidth: 3,
          columnHeaderTooltip: 'Federal and state asset location',
        },
      },
      styles: {
        rowPaddingVertical: 1,
        columnPaddingHorizontal: 3,
      },
    },
    assets: {
      columns: {
        assetName: { columnHeader: 'Name', columnWidth: 6 },
        ownerId: { columnHeader: 'Owner', columnWidth: 6 },
        assetCategoryId: {
          columnHeader: '',
          columnSubheader: 'Asset category',
          columnWidth: 6,
        },
        valuation: {
          columnHeader: '',
          columnSubheader: 'Valuation',
          columnWidth: 6,
        },
      },
      styles: { rowPaddingVertical: 2, columnPaddingHorizontal: 1.5 },
    },
    liabilities: {
      columns: {
        name: { columnHeader: 'Name', columnWidth: 4 },
        recipientId: { columnHeader: 'Debtor', columnWidth: 4 },
        issuerId: { columnHeader: 'Lender', columnWidth: 4 },
        outstandingBalance: {
          columnHeader: '',
          columnSubheader: 'Outstanding balance',
          columnWidth: 12,
        },
        // Additional fields not displayed in table but required by LiabilityFormShape
        _showExpandedPaymentDetails: {
          columnHeader: '',
          columnWidth: 1,
        },
        balanceAsOfDate: { columnHeader: '', columnWidth: 1 },
        paymentFrequency: { columnHeader: '', columnWidth: 1 },
        interestRate: { columnHeader: '', columnWidth: 1 },
        termStartDate: { columnHeader: '', columnWidth: 1 },
        termEndDate: { columnHeader: '', columnWidth: 1 },
        paymentKind: { columnHeader: '', columnWidth: 1 },
        paymentAmount: { columnHeader: '', columnWidth: 1 },
        notes: { columnHeader: '', columnWidth: 1 },
        hasDifferentPaymentSource: {
          columnHeader: '',
          columnWidth: 1,
        },
        alternateSourceId: {
          columnHeader: '',
          columnWidth: 1,
        },
        integrationLiabilityId: {
          columnHeader: '',
          columnWidth: 1,
        },
      },
      styles: { rowPaddingVertical: 2, columnPaddingHorizontal: 1.5 },
    },
    lifeInsurancePolicies: {
      columns: {
        policyType: { columnHeader: 'Policy type', columnWidth: 6 },
        ownerId: { columnHeader: 'Owner', columnWidth: 6 },
        policyHolderIDs: {
          columnHeader: '',
          columnSubheader: 'Insured',
          columnWidth: 6,
        },
        deathBenefitAmount: {
          columnHeader: '',
          columnSubheader: 'Death benefit amount',
          columnWidth: 6,
        },
        // Additional fields not displayed in table but required by InsurancePolicyDetails
        insuranceCarrier: { columnHeader: '', columnWidth: 1 },
        policyId: { columnHeader: '', columnWidth: 1 },
        integrationInsuranceId: { columnHeader: '', columnWidth: 1 },
        conversionDate: { columnHeader: '', columnWidth: 1 },
        isConvertible: { columnHeader: '', columnWidth: 1 },
        policyNumber: { columnHeader: '', columnWidth: 1 },
        initialPolicyHolderIDs: {
          columnHeader: '',
          columnWidth: 1,
        },
        policyStartDate: { columnHeader: '', columnWidth: 1 },
        termLength: { columnHeader: '', columnWidth: 1 },
        premiumAmount: { columnHeader: '', columnWidth: 1 },
        premiumFrequency: { columnHeader: '', columnWidth: 1 },
        premiumInitialDueDate: {
          columnHeader: '',
          columnWidth: 1,
        },
        premiumPaymentSourceID: {
          columnHeader: '',
          columnWidth: 1,
        },
        premiumPaymentSourceKind: {
          columnHeader: '',
          columnWidth: 1,
        },
        premiumPaymentTransferTaxKind: {
          columnHeader: '',
          columnWidth: 1,
        },
        premiumPaymentGiftingGrantorIDs: {
          columnHeader: '',
          columnWidth: 1,
        },
        notes: { columnHeader: '', columnWidth: 1 },
        documentIds: { columnHeader: '', columnWidth: 1 },
        initialDocumentIDs: {
          columnHeader: '',
          columnWidth: 1,
        },
        initialPremiumPaymentGiftingGrantorIDs: {
          columnHeader: '',
          columnWidth: 1,
        },
        cashValue: { columnHeader: '', columnWidth: 1 },
        cashValueDate: { columnHeader: '', columnWidth: 1 },
        loanBalanceOutstanding: {
          columnHeader: '',
          columnWidth: 1,
        },
      },
      styles: { rowPaddingVertical: 2, columnPaddingHorizontal: 1.5 },
    },
  };

/**
 * Default empty values of the form
 */
export function getDefaultData(): AIOnboardingModalFormShape {
  return {
    individuals: [],
    organizations: [],
    entities: [],
    testamentaryEntities: [],
    assets: [],
    liabilities: [],
    lifeInsurancePolicies: [],
  };
}
